export default function PdfPageSplitIcon({
  size = 18,
  strokeColor = "#C8CCD8",
}: {
  size?: number;
  strokeColor?: string;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 3.8C1 2.2536 2.2536 1 3.8 1H11C12.5464 1 13.8 2.2536 13.8 3.8V7.8C13.8 9.3464 12.5464 10.6 11 10.6H3.8C2.25361 10.6 1 9.3464 1 7.8V3.8Z"
        stroke={strokeColor}
      />
      <path
        d="M13.8002 4.19995H14.2002C15.7466 4.19995 17.0002 5.45355 17.0002 6.99995V11C17.0002 12.5464 15.7466 13.8 14.2002 13.8H10.6002H7.0002C5.4538 13.8 4.2002 12.5463 4.2002 11V10.6"
        stroke={strokeColor}
      />
      <path
        d="M17.0004 7.3999H17.4004C18.9468 7.3999 20.2004 8.65351 20.2004 10.1999V14.1999C20.2004 15.7463 18.9468 16.9999 17.4004 16.9999H13.8004H10.2004C8.654 16.9999 7.40039 15.7463 7.40039 14.1999V13.7999"
        stroke={strokeColor}
      />
    </svg>
  );
}
